export default __webpack_public_path__ + "static/media/1.2097fa1d.png";